// =============================================================
// Preferencias de UI por usuario.
//
// Fonte de verdade em runtime: localStorage.sessionPrefs (JSON string).
// Persistencia por usuario: backend (migration 0032 + PUT
// v1/usuarios/preferencias); o login devolve a string e sincroniza aqui.
//
// setPref aplica na hora (localStorage) e persiste no backend em best-effort:
// se o endpoint ainda nao existir no binario publicado, a UI segue funcionando
// (fica salvo so no dispositivo) sem quebrar.
// =============================================================
import api from '../services/api';

const SK_PREFS = 'sessionPrefs';

export function getPrefs() {
  try {
    const raw = localStorage.getItem(SK_PREFS);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function getPref(key, fallback = undefined) {
  const prefs = getPrefs();
  return Object.prototype.hasOwnProperty.call(prefs, key) ? prefs[key] : fallback;
}

// Atualiza a preferencia: aplica no dispositivo e persiste no backend (best-effort).
export function setPref(key, value) {
  const prefs = getPrefs();
  prefs[key] = value;
  const str = JSON.stringify(prefs);
  localStorage.setItem(SK_PREFS, str);
  // Nao bloqueia a UI nem quebra se o endpoint ainda nao estiver publicado.
  api.put('v1/usuarios/preferencias', { preferencias: str }).catch(() => {});
  return prefs;
}

// Chamado no login (salvarSessao): grava no localStorage o que veio do backend.
export function syncPrefsFromLogin(raw) {
  try {
    const parsed = raw ? JSON.parse(raw) : {};
    localStorage.setItem(SK_PREFS, JSON.stringify(parsed && typeof parsed === 'object' ? parsed : {}));
  } catch {
    localStorage.setItem(SK_PREFS, '{}');
  }
}
